module.exports = __webpack_public_path__ + "static/media/q4.3230957e.svg";